/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { otheritemsindex } from './otheritemsindex';

export class otheritems extends IceEntity {
  other_items_key: string = "";
  item_stock_num: string = "";
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  sku_num: string = "";
  itm_name: string = "";
  itm_desc: string = "";
  service_option: boolean = false;
  cosmetic_option: boolean = false;
  code: string = "";
  code_list_qualifier_code: string = "";
  code_txt: string = "";
  inc_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  sal_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  inv_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_ser_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_sup_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_inv_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  tax_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cost: number = 0.0;
  price: number = 0.0;
  net: number = 0.0;
  unit_type: string = "";
  cost_method: IceTypes.InventoryMethod = IceTypes.InventoryMethod.imFIFO;
  reorder_level: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  constructor(cpy?: otheritemsindex) {
    super();

    if (cpy != null) {
      this.other_items_key = cpy.other_items_key;
      this.item_stock_num = cpy.item_stock_num;
      this.tax_status = cpy.tax_status;
      this.sku_num = cpy.sku_num;
      this.itm_name = cpy.itm_name;
      this.itm_desc = cpy.itm_desc;
      this.service_option = cpy.service_option;
      this.cosmetic_option = cpy.cosmetic_option;
      this.code = cpy.code;
      this.code_list_qualifier_code = cpy.code_list_qualifier_code;
      this.code_txt = cpy.code_txt;
      this.cost = cpy.cost;
      this.price = cpy.price;
      this.net = cpy.net;
      this.unit_type = cpy.unit_type;
    }
  }

  gettablename(): string {
    return "OTHER_ITEMS";
  }
}
